import { Component, Inject, OnInit } from '@angular/core';
import { Client } from '../../../components/client/classes/client';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService } from '../../../services/message-service/message.service';
import { StammdatenService } from '../../../components/stammdaten/stammdaten.service';
import { debounceTime, Observable, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { KieneApi } from '../../../services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';

const BETRIEB_LIST_LIMIT = 50;

@Component({
    selector: 'kiene-betrieb-auswaehlen-dialog',
    templateUrl: './betrieb-auswaehlen-dialog.component.html',
    styleUrls: ['./betrieb-auswaehlen-dialog.component.scss'],
})
export class BetriebAuswaehlenDialogComponent implements OnInit {
    selectedVvvo: Client;
    vvvos: Client[] = [];
    isLoading = true;

    headline = 'Betrieb auswählen';

    /** When true, list includes freigegebene Betriebe in addition to meine Betriebe. */
    mitFreigegebenenBetrieben = false;

    /** Gruppen-Inhaber (kunde_id): fuer Tierarzt/Admin im Umstallen-Dialog. */
    inhaberKundeId: number | null = null;

    alleAuswaehlenButtonZeigen = true;
    searchCtrl = new FormControl();
    private vvvoSub: Subscription;

    constructor(
        public dialogRef: MatDialogRef<BetriebAuswaehlenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
        private stammdatenService: StammdatenService,
    ) {
        if (this.data) {
            if (this.data.alleAuswahlenButtonZeigen) {
                this.alleAuswaehlenButtonZeigen = this.data.alleAuswaehlenButtonZeigen;
            }
            if (this.data.headline) {
                this.headline = this.data.headline;
            }
            if (this.data.mitFreigegebenenBetrieben) {
                this.mitFreigegebenenBetrieben = true;
            }
            const inhaberKundeId = Number(this.data.inhaberKundeId);
            if (inhaberKundeId > 0) {
                this.inhaberKundeId = inhaberKundeId;
            }
        }
    }

    ngOnInit(): void {
        this.searchCtrl.valueChanges.pipe(debounceTime(300)).subscribe({
            next: () => {
                this.loadVvvos();
            },
        });

        this.selectedVvvo = this.localStorageService.getCurrentClient();
        this.localStorageService.watchCurrentClient().subscribe({
            next: (client: Client) => {
                this.selectedVvvo = client;
            },
        });
        this.loadVvvos();
    }

    loadVvvos() {
        this.isLoading = true;
        this.vvvoSub?.unsubscribe();
        const search = this.searchCtrl.value;
        const load$ = this.getBetriebeLoadObservable(search);
        this.vvvoSub = load$.subscribe({
            next: resp => {
                this.isLoading = false;
                this.vvvos = resp.records;
                if (!this.searchCtrl.value && this.vvvos?.length === 1) {
                    this.messageService.infoMessage('Einzigen Betrieb automatisch ausgewählt!');
                    this.betriebAuswaehlen(this.vvvos[0]);
                }
            },
            error: err => {
                this.isLoading = false;
                this.messageService.errorMessage('Fehler beim Laden der Betriebe!', err);
            },
        });
    }

    betriebAuswaehlen(vvvo: Client) {
        this.dialogRef.close(vvvo);
    }

    betriebAbwaehlen() {
        this.localStorageService.setCurrentClient(undefined, 'BetriebAuswaehlenDialogComponent');
    }

    /**
     * Landwirt/Viehhändler: eigene + freigegebene Betriebe.
     * Tierarzt/Admin mit inhaberKundeId: dasselbe für das Landwirt-Konto der Gruppe.
     * Sonst: alle Mandanten-Kunden (VVVO-Auswahl etc.).
     */
    private getBetriebeLoadObservable(search?: string): Observable<KieneApi> {
        if (this.localStorageService.isCurrentUserKunde() || this.localStorageService.isCurrentUserViehhaendler()) {
            return this.stammdatenService.ladeMeineUndFreigegebeneVvvos(search, BETRIEB_LIST_LIMIT);
        }
        if (this.inhaberKundeId > 0) {
            return this.stammdatenService.ladeZielbetriebeFuerInhaber(this.inhaberKundeId, search, BETRIEB_LIST_LIMIT);
        }
        if (this.mitFreigegebenenBetrieben) {
            return this.stammdatenService.ladeMeineUndFreigegebeneVvvos(search, BETRIEB_LIST_LIMIT);
        }
        return this.stammdatenService.ladeVvvos(search, BETRIEB_LIST_LIMIT);
    }
}
